"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensValidation = exports.OrderInputValidation = exports.Status = exports.TWAPLib = void 0;
const web3_1 = __importDefault(require("web3"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const web3_candies_1 = require("@defi.org/web3-candies");
const paraswap_1 = require("./paraswap");
const lodash_1 = __importDefault(require("lodash"));
const odos_1 = require("./odos");
const openocean_1 = require("./openocean");
class TWAPLib {
    constructor(config, maker, provider) {
        this.config = config;
        this.maker = maker;
        this.provider = provider;
        this.dstAmount = (srcToken, dstToken, srcAmount, srcUsdMarket, dstUsdMarket, limitDstPriceFor1Src, isMarketOrder) => (0, web3_candies_1.convertDecimals)(isMarketOrder ? (0, bignumber_js_1.default)(srcAmount).times(srcUsdMarket).div(dstUsdMarket) : (0, bignumber_js_1.default)(srcAmount).times(limitDstPriceFor1Src), srcToken.decimals, dstToken.decimals).integerValue(bignumber_js_1.default.ROUND_FLOOR);
        this.isNativeToken = (token) => (0, web3_candies_1.isNativeAddress)(token.address);
        this.isWrappedToken = (token) => (0, web3_candies_1.eqIgnoreCase)(token.address, this.config.wToken.address);
        this.isValidChain = (chainId) => chainId === this.config.chainId;
        this.maxPossibleChunks = (srcToken, srcAmount, srcUsd) => bignumber_js_1.default.max(1, (0, bignumber_js_1.default)(srcAmount).div((0, bignumber_js_1.default)(10).pow(srcToken.decimals).div(srcUsd).times(this.config.minChunkSizeUsd)))
            .integerValue(bignumber_js_1.default.ROUND_FLOOR)
            .toNumber();
        this.srcChunkAmount = (srcAmount, totalChunks) => (0, bignumber_js_1.default)(srcAmount).div(totalChunks).integerValue(bignumber_js_1.default.ROUND_FLOOR);
        this.totalChunks = (srcAmount, srcChunkAmount) => (0, bignumber_js_1.default)(srcAmount).div(srcChunkAmount).integerValue(bignumber_js_1.default.ROUND_CEIL).toNumber();
        this.estimatedDelayBetweenChunksMillis = () => this.config.bidDelaySeconds * 1000 * 2;
        /**
         * includes the bidding war and block settelment
         */
        this.fillDelayUiMillis = (totalChunks, maxDurationMillis) => bignumber_js_1.default.max((0, bignumber_js_1.default)(totalChunks).gt(1) ? (0, bignumber_js_1.default)(maxDurationMillis).div(totalChunks) : 0, (0, bignumber_js_1.default)(this.estimatedDelayBetweenChunksMillis())).toNumber();
        this.fillDelayMillis = (totalChunks, maxDurationMillis) => this.fillDelayUiMillis(totalChunks, maxDurationMillis) - this.estimatedDelayBetweenChunksMillis();
        this.dstMinAmountOut = (srcToken, dstToken, srcChunkAmount, limitDstPriceFor1Src, isMarketOrder) => isMarketOrder
            ? (0, bignumber_js_1.default)(1)
            : bignumber_js_1.default.max(1, (0, web3_candies_1.convertDecimals)((0, bignumber_js_1.default)(srcChunkAmount).times(limitDstPriceFor1Src), srcToken.decimals, dstToken.decimals).integerValue(bignumber_js_1.default.ROUND_FLOOR));
        this.dstPriceFor1Src = (srcToken, dstToken, srcUsdMarket, dstUsdMarket, srcChunkAmount, dstMinAmountOut) => (0, bignumber_js_1.default)(dstMinAmountOut).eq(1)
            ? (0, bignumber_js_1.default)(srcUsdMarket).div(dstUsdMarket)
            : (0, bignumber_js_1.default)(dstMinAmountOut).div((0, web3_candies_1.convertDecimals)((0, bignumber_js_1.default)(srcChunkAmount), srcToken.decimals, dstToken.decimals));
        this.isMarketOrder = (order) => order.ask.dstMinAmount.lte(1);
        this.orderProgress = (order) => parseFloat(order.srcFilledAmount.div(order.ask.srcAmount).toFixed(4));
        this.percentAboveMarket = (srcUsdMarket, dstUsdMarket, limitDstPriceFor1Src) => parseFloat((0, bignumber_js_1.default)(limitDstPriceFor1Src).div((0, bignumber_js_1.default)(srcUsdMarket).div(dstUsdMarket)).minus(1).toFixed(4));
        this.status = (order) => order.status > Date.now() / 1000
            ? Status.Open
            : order.status === 1
                ? Status.Canceled
                : order.status === 2
                    ? Status.Completed
                    : Status.Expired;
        if (provider)
            (0, web3_candies_1.setWeb3Instance)(new web3_1.default(provider));
        this.twap = (0, web3_candies_1.contract)(config.twapAbi, config.twapAddress);
        this.lens = (0, web3_candies_1.contract)(config.lensAbi, config.lensAddress);
    }
    makerBalance(token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isNativeToken(token))
                return (0, web3_candies_1.web3)().eth.getBalance(this.maker).then(bignumber_js_1.default);
            else
                return (0, web3_candies_1.erc20)(token.symbol, token.address, token.decimals).methods.balanceOf(this.maker).call().then(bignumber_js_1.default);
        });
    }
    wrapNativeToken(amount, maxPriorityFeePerGas, maxFeePerGas) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, web3_candies_1.sendAndWaitForConfirmations)((0, web3_candies_1.erc20)(this.config.wToken.symbol, this.config.wToken.address, this.config.wToken.decimals, web3_candies_1.iwethabi).methods.deposit(), { from: this.maker, maxPriorityFeePerGas, maxFeePerGas, value: amount });
        });
    }
    unwrapNativeToken(amount, maxPriorityFeePerGas, maxFeePerGas) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, web3_candies_1.sendAndWaitForConfirmations)((0, web3_candies_1.erc20)(this.config.wToken.symbol, this.config.wToken.address, this.config.wToken.decimals, web3_candies_1.iwethabi).methods.withdraw((0, bignumber_js_1.default)(amount).toFixed(0)), { from: this.maker, maxPriorityFeePerGas, maxFeePerGas });
        });
    }
    hasAllowance(srcToken, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isNativeToken(srcToken))
                return true;
            const token = (0, web3_candies_1.erc20)(srcToken.symbol, srcToken.address, srcToken.decimals);
            const allowance = (0, bignumber_js_1.default)(yield token.methods.allowance(this.maker, this.config.twapAddress).call());
            return allowance.gte(amount);
        });
    }
    approve(srcToken, amount, maxPriorityFeePerGas, maxFeePerGas) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = (0, web3_candies_1.erc20)(srcToken.symbol, srcToken.address, srcToken.decimals);
            yield (0, web3_candies_1.sendAndWaitForConfirmations)(token.methods.approve(this.config.twapAddress, (0, bignumber_js_1.default)(amount).toFixed(0)), {
                from: this.maker,
                maxPriorityFeePerGas,
                maxFeePerGas,
            });
        });
    }
    validateTokens(srcToken, dstToken) {
        if (lodash_1.default.isEqual(srcToken, dstToken) || (this.isNativeToken(srcToken) && this.isNativeToken(dstToken)))
            return TokensValidation.invalid;
        if (this.isNativeToken(srcToken)) {
            if (this.isWrappedToken(dstToken))
                return TokensValidation.wrapOnly;
            return TokensValidation.wrapAndOrder;
        }
        if (this.isWrappedToken(srcToken) && this.isNativeToken(dstToken))
            return TokensValidation.unwrapOnly;
        if (this.isNativeToken(dstToken))
            return TokensValidation.dstTokenZero;
        return TokensValidation.valid;
    }
    validateOrderInputs(srcToken, dstToken, srcAmount, srcChunkAmount, dstMinChunkAmountOut, deadline, fillDelaySeconds, srcUsd) {
        const tokensValidation = this.validateTokens(srcToken, dstToken);
        if (tokensValidation === TokensValidation.invalid)
            return OrderInputValidation.invalidTokens;
        if ((0, bignumber_js_1.default)(srcAmount).lte(0))
            return OrderInputValidation.invalidSrcAmount;
        if ((0, bignumber_js_1.default)(srcChunkAmount).lte(0) || (0, bignumber_js_1.default)(srcChunkAmount).gt(srcAmount))
            return OrderInputValidation.invalidSrcChunkAmount;
        if ((0, bignumber_js_1.default)(dstMinChunkAmountOut).lte(0))
            return OrderInputValidation.invalidDstMinChunkAmountOut;
        if ((0, bignumber_js_1.default)(deadline).integerValue(bignumber_js_1.default.ROUND_FLOOR).lte(Date.now()))
            return OrderInputValidation.invalidDeadline;
        if ((0, bignumber_js_1.default)(fillDelaySeconds).integerValue(bignumber_js_1.default.ROUND_FLOOR).lt(0))
            return OrderInputValidation.invalidFillDelaySeconds;
        if ((0, bignumber_js_1.default)(srcUsd).lte(0))
            return OrderInputValidation.invalidSrcUsd;
        if ((0, bignumber_js_1.default)(srcChunkAmount)
            .times(srcUsd)
            .lt((0, bignumber_js_1.default)(this.config.minChunkSizeUsd).times((0, bignumber_js_1.default)(10).pow(srcToken.decimals))))
            return OrderInputValidation.invalidSmallestSrcChunkUsd;
        return OrderInputValidation.valid;
    }
    submitOrder(srcToken, dstToken, srcAmount, srcChunkAmount, dstMinChunkAmountOut, deadline, fillDelaySeconds, srcUsd, askDataParams = [], maxPriorityFeePerGas, maxFeePerGas) {
        return __awaiter(this, void 0, void 0, function* () {
            const validation = this.validateOrderInputs(srcToken, dstToken, srcAmount, srcChunkAmount, dstMinChunkAmountOut, deadline, fillDelaySeconds, srcUsd);
            if (validation !== OrderInputValidation.valid)
                throw new Error(`invalid inputs: ${validation}`);
            const askData = this.config.exchangeType === "PangolinDaasExchange"
                ? (0, web3_candies_1.web3)().eth.abi.encodeParameters(["address"], askDataParams)
                : [];
            const askParams = [
                this.config.exchangeAddress,
                srcToken.address,
                dstToken.address,
                (0, bignumber_js_1.default)(srcAmount).toFixed(0),
                (0, bignumber_js_1.default)(srcChunkAmount).toFixed(0),
                (0, bignumber_js_1.default)(dstMinChunkAmountOut).toFixed(0),
                (0, bignumber_js_1.default)(deadline).div(1000).toFixed(0),
                (0, bignumber_js_1.default)(this.config.bidDelaySeconds).toFixed(0),
                (0, bignumber_js_1.default)(fillDelaySeconds).toFixed(0),
            ];
            let ask;
            if (this.config.twapVersion > 3) {
                askParams.push(askData);
                ask = this.twap.methods.ask(askParams);
            }
            else {
                ask = this.twap.methods.ask(...askParams);
            }
            const tx = yield (0, web3_candies_1.sendAndWaitForConfirmations)(ask, {
                from: this.maker,
                maxPriorityFeePerGas,
                maxFeePerGas,
            });
            const events = (0, web3_candies_1.parseEvents)(tx, this.twap.options.jsonInterface);
            return Number(events[0].returnValues.id);
        });
    }
    getOrder(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.parseOrder(yield this.twap.methods.order(id).call());
        });
    }
    cancelOrder(id, maxPriorityFeePerGas, maxFeePerGas) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, web3_candies_1.sendAndWaitForConfirmations)(this.twap.methods.cancel(id), {
                from: this.maker,
                maxPriorityFeePerGas,
                maxFeePerGas,
            });
        });
    }
    getAllOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            return lodash_1.default.filter(lodash_1.default.map(yield this.lens.methods.makerOrders(this.maker).call(), (o) => this.parseOrder(o)), (o) => (0, web3_candies_1.eqIgnoreCase)(o.ask.exchange, this.config.exchangeAddress));
        });
    }
    getAllOrdersWithTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            const orders = yield this.getAllOrders();
            const tokens = yield Promise.all(lodash_1.default.map(lodash_1.default.uniq(lodash_1.default.concat(lodash_1.default.map(orders, (o) => o.ask.srcToken), lodash_1.default.map(orders, (o) => o.ask.dstToken))), (a) => this.getToken(a)));
            return lodash_1.default.map(orders, (o) => lodash_1.default.merge(o, {
                srcToken: lodash_1.default.find(tokens, (t) => (0, web3_candies_1.eqIgnoreCase)(t.address, o.ask.srcToken)),
                dstToken: lodash_1.default.find(tokens, (t) => (0, web3_candies_1.eqIgnoreCase)(t.address, o.ask.dstToken)),
            }));
        });
    }
    parseOrder(r) {
        var _a, _b, _c, _d, _e, _f;
        return {
            id: Number(r.id),
            status: Number(r.status),
            time: Number(r.time || r.ask.time),
            filledTime: Number(r.filledTime),
            srcFilledAmount: (0, bignumber_js_1.default)(r.srcFilledAmount),
            maker: web3_1.default.utils.toChecksumAddress(r.maker || r.ask.maker),
            ask: {
                deadline: Number(r.ask.deadline),
                bidDelay: Number(r.ask.bidDelay),
                fillDelay: Number(r.ask.fillDelay),
                exchange: web3_1.default.utils.toChecksumAddress(r.ask.exchange),
                srcToken: web3_1.default.utils.toChecksumAddress(r.ask.srcToken),
                dstToken: web3_1.default.utils.toChecksumAddress(r.ask.dstToken),
                srcAmount: (0, bignumber_js_1.default)(r.ask.srcAmount),
                srcBidAmount: (0, bignumber_js_1.default)(r.ask.srcBidAmount),
                dstMinAmount: (0, bignumber_js_1.default)(r.ask.dstMinAmount),
            },
            bid: {
                time: Number(((_a = r.bid) === null || _a === void 0 ? void 0 : _a.time) || 0),
                taker: web3_1.default.utils.toChecksumAddress(((_b = r.bid) === null || _b === void 0 ? void 0 : _b.taker) || web3_candies_1.zeroAddress),
                exchange: web3_1.default.utils.toChecksumAddress(((_c = r.bid) === null || _c === void 0 ? void 0 : _c.exchange) || web3_candies_1.zeroAddress),
                dstAmount: (0, bignumber_js_1.default)(((_d = r.bid) === null || _d === void 0 ? void 0 : _d.dstAmount) || web3_candies_1.zero),
                dstFee: (0, bignumber_js_1.default)(((_e = r.bid) === null || _e === void 0 ? void 0 : _e.dstFee) || web3_candies_1.zero),
                data: ((_f = r.bid) === null || _f === void 0 ? void 0 : _f.data) || "",
            },
        };
    }
    getToken(address) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((0, web3_candies_1.isNativeAddress)(address))
                return this.config.nativeToken;
            if ((0, web3_candies_1.eqIgnoreCase)(address, this.config.wToken.address))
                return this.config.wToken;
            address = web3_1.default.utils.toChecksumAddress(address);
            const t = (0, web3_candies_1.erc20)(address, address);
            const [decimals, symbol] = yield Promise.all([t.decimals(), t.methods.symbol().call()]);
            return { address, decimals, symbol };
        });
    }
    priceUsd(token) {
        return __awaiter(this, void 0, void 0, function* () {
            token = (0, web3_candies_1.isNativeAddress)(token.address) ? this.config.wToken : token;
            const r = yield this.solverRoute(token, this.config.nativeToken, (0, bignumber_js_1.default)(10).pow(token.decimals));
            return r.srcUsd.toNumber();
        });
    }
    findRoute(srcToken, dstToken, srcAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = yield this.solverRoute(srcToken, dstToken, srcAmount);
            return Object.assign(Object.assign({}, route), { data: this.encodeBidData(route), srcToken, dstToken, srcAmount });
        });
    }
    solverRoute(srcToken, dstToken, srcAmount) {
        switch (this.config.exchangeType) {
            case "OdosExchange":
                return odos_1.Odos.findRoute(this.config.chainId, srcToken, dstToken, srcAmount, this.config.exchangeAddress, this.config.pathfinderKey, this.config.partner);
            case "OpenOceanExchange":
                return openocean_1.OpenOcean.findRoute(this.config.chainId, srcToken, dstToken, srcAmount, this.config.exchangeAddress, this.config.pathfinderKey, this.config.partner);
            default:
                return paraswap_1.Paraswap.findRoute(this.config.chainId, srcToken, dstToken, srcAmount, this.config.exchangeAddress, this.config.pathfinderKey, this.config.partner);
        }
    }
    findRouteForNextBid(order) {
        return __awaiter(this, void 0, void 0, function* () {
            if (order.ask.exchange !== web3_candies_1.zeroAddress && !(0, web3_candies_1.eqIgnoreCase)(order.ask.exchange, this.config.exchangeAddress))
                throw new Error(`mismatched exchange and config`);
            const srcNextChunkAmountIn = bignumber_js_1.default.min(order.ask.srcBidAmount, order.ask.srcAmount.minus(order.srcFilledAmount));
            const [srcToken, dstToken] = yield Promise.all([
                this.getToken(order.ask.srcToken),
                this.getToken(order.ask.dstToken),
            ]);
            return yield this.findRoute(srcToken, dstToken, srcNextChunkAmountIn);
        });
    }
    encodeBidData(route) {
        switch (this.config.exchangeType) {
            case "UniswapV2Exchange":
            case "PangolinDaasExchange":
                return (0, web3_candies_1.web3)().eth.abi.encodeParameters(["bool", "address[]"], [true, route.path]);
            case "ParaswapExchange":
            case "OdosExchange":
            case "OpenOceanExchange":
                return (0, web3_candies_1.web3)().eth.abi.encodeParameters(["uint256", "bytes"], [route.dstAmount.toFixed(0), route.data]);
            default:
                throw new Error(`unknown exchange type ${this.config.exchangeType}`);
        }
    }
}
exports.TWAPLib = TWAPLib;
TWAPLib.VERSION = 4;
var Status;
(function (Status) {
    Status["Open"] = "Open";
    Status["Canceled"] = "Canceled";
    Status["Completed"] = "Completed";
    Status["Expired"] = "Expired";
})(Status = exports.Status || (exports.Status = {}));
var OrderInputValidation;
(function (OrderInputValidation) {
    OrderInputValidation["valid"] = "valid";
    OrderInputValidation["invalidTokens"] = "invalidTokens";
    OrderInputValidation["invalidSrcAmount"] = "invalidSrcAmount";
    OrderInputValidation["invalidSrcChunkAmount"] = "invalidSrcChunkAmount";
    OrderInputValidation["invalidDstMinChunkAmountOut"] = "invalidDstMinChunkAmountOut";
    OrderInputValidation["invalidDeadline"] = "invalidDeadline";
    OrderInputValidation["invalidFillDelaySeconds"] = "invalidFillDelaySeconds";
    OrderInputValidation["invalidSrcUsd"] = "invalidSrcUsd";
    OrderInputValidation["invalidSmallestSrcChunkUsd"] = "invalidSmallestSrcChunkUsd";
})(OrderInputValidation = exports.OrderInputValidation || (exports.OrderInputValidation = {}));
var TokensValidation;
(function (TokensValidation) {
    TokensValidation["valid"] = "valid";
    TokensValidation["invalid"] = "invalid";
    TokensValidation["wrapOnly"] = "wrapOnly";
    TokensValidation["unwrapOnly"] = "unwrapOnly";
    TokensValidation["wrapAndOrder"] = "wrapAndOrder";
    TokensValidation["dstTokenZero"] = "dstTokenZero";
})(TokensValidation = exports.TokensValidation || (exports.TokensValidation = {}));
